import { Button, StylovyzeComposableDialog } from '@innovyze/stylovyze';
import { useGlobalization } from '@Translations/useGlobalization';
import React from 'react';

interface Props {
	onCancel: () => void;
	onDelete: () => void;
	open: boolean;
}

export default function DeleteIntegrationModal({
	open,
	onCancel,
	onDelete,
}: Props) {
	const { t } = useGlobalization();
	return (
		<StylovyzeComposableDialog
			open={open}
			onCancel={onCancel}
			footer={
				<>
					<Button
						dataCy="deleteLiftStationModal"
						variant="contained"
						color="error"
						onClick={onDelete}>
						{t('Delete')}
					</Button>
					<Button
						dataCy="cancelModal"
						variant="contained"
						color="secondary"
						onClick={onCancel}>
						{t('Cancel')}
					</Button>
				</>
			}
			title={t('Delete integration')}>
			<div>
				{t(
					'Are you sure you want to delete this integration? This action cannot be undone.',
				)}
				<br />
				<br />
				{t(
					'Once deleted, you will no longer be able to connect to data using this integration, and any existing data that is syncing will no longer sync.',
				)}
			</div>
		</StylovyzeComposableDialog>
	);
}
